import styled from '@emotion/styled';
import css from '@emotion/css';
import BasicModal from 'components/Modals/presets/BasicModal';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  > div {
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex: 1;
    text-align: center;
  }
`;

export const StyledBasicModal = styled(BasicModal)`
  ${({ diffPaddings }) =>
    diffPaddings &&
    css`.modal-footer button.btn {
    margin-left: 15px;`}
`;
